import { render, staticRenderFns } from "./new6.vue?vue&type=template&id=24a9565e&scoped=true&"
import script from "./new6.vue?vue&type=script&lang=js&"
export * from "./new6.vue?vue&type=script&lang=js&"
import style0 from "./new6.vue?vue&type=style&index=0&id=24a9565e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9565e",
  null
  
)

export default component.exports